import React, { useState } from 'react';
import './NewsletterSignUp.scss';
import Input from '../../UI/Input/Input';
import { useForm } from 'react-hook-form';
import { emailPattern } from '../../../util/regex/emailPattern';
import { onSubmit } from '../../../util/onSubmit';
import ErrorMessage from './ErrorMessage/ErrorMessage';
import { HUBSPOT_FORM_CONFIG } from '../../../constants/hubspotFormConfig';

/**
 * Renders the newsletter sign up
 * @param {string} title - the form title
 * @param {string} color - color to pass to input child (for dark/light modes)
 * @returns {JSX.Element}
 * @constructor
 */
const NewsletterSignUp = ({ title = null, color }) => {
  const { register, handleSubmit, errors, trigger, formState } = useForm({ mode: 'onChange' });
  const [formComplete, setFormComplete] = useState(false);
  const [status, setStatus] = useState(null);

  const formUrl = `${HUBSPOT_FORM_CONFIG.FORM_URL}/${HUBSPOT_FORM_CONFIG.HUBSPOT_ID}/${HUBSPOT_FORM_CONFIG.NEWSLETTER.GUID}`;

  const formHandler = async (data, e) => {
    try {
      e.preventDefault();
      await onSubmit(formUrl, data, callbacks);
    } catch (error) {
      throw new Error(error);
    }
  };

  const callbacks = {
    onError: () => {
      setStatus('error');
    },
    onSuccess: () => {
      setFormComplete(true);
    },
  };

  return (
    <div className="c-newsletter-sign-up">
      {title && (
        <div className="c-newsletter-sign-up__title h3-roobert">
          <h3>{title}</h3>
        </div>
      )}
      <div className="c-newsletter-sign-up__input">
        <form className="c-newsletter-sign-up__form" onSubmit={handleSubmit(formHandler)}>
          {!formComplete && (
            <>
              <Input
                id={'email'}
                type={'text'}
                name={'email'}
                placeholder={'Enter your email'}
                color={color}
                fieldRef={register({
                  required: true,
                  pattern: emailPattern,
                })}
                onBlur={() => trigger('email')}
                isDisabled={!formState.isValid}
              />
              {errors['email'] && <ErrorMessage message={'Please enter a valid email address'} />}
            </>
          )}
          {formComplete && (
            <div className="h3-roobert color-white">
              <h3>Thank you!</h3>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default NewsletterSignUp;
